import Register from "../../components/Auth/Register";

export default function SignUp() {
  return <Register />;
}
